<template>
    <!-- 查看货权 -->
    <div class="templete">
        <!-- <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.redeem_order_sn" placeholder="赎货单号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('advissuing')">
                <el-option v-for="(list,index) in selectMap.advissuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="赎货状态" @visible-change="getSelectList('advstatus')">
                <el-option v-for="(list,index) in selectMap.advstatus" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div> -->
        <div>
            <div class="filterBtns" @click="filterDialogVisible=!filterDialogVisible"></div>
        </div>
        <div class="tableBox">
            <tabletem :isShowIndex="true" :isSetCol="true" :isHideColumn="false" scene="pledge.goods.power" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber">合计：</div>
            <div class="totalNumber">监管数量:{{tot.property_cube}}m³</div>
            <div class="totalNumber">可发方数:{{tot.supervise_cube}}m³</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="pledge.goods.power" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue';
    import pagination from '../../../../components/pagination.vue';
    export default {
        data(){
            return {
                module: localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    redeem_order_sn:""
                },
                last_page:1,
                total:0,
                tot:{},
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                isGlobal:false,
                tableLoading:false,
                selectRow:[],
                tableCol:[
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"融资提单",colKey:"order_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"监管方数",colKey:"supervise_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"可发方数",colKey:"property_cube",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,},
                ],
                list:[],
                selectMap:{
                    advissuing:[],
                    redeemstatus:[],
                    redeemsales:[],
                    paymentType:[],
                    account:[],
                    user:[],
                    inventoryissuing:[],
                },
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            // this.getSelectList('user');
            // this.getSelectList('account');
            // this.getSelectList('paymentType');
            // this.getSelectList('advstatus');
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/pledge.goods.power",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.tot= res.data.data.total;
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        // item.baseColor = "";
                        // this.list[index].redeem_date = this.formatTime(item.redeem_date+"000")
                        // if(item.status_text=='待付款'){
                        //     item.baseColor='red';
                        // }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                // this.scene = 'redeem.advance.column';
                // this.isGlobal = true;
                // this.getBillColumn();
                // if(obj.name =='redeem_order_sn'){
                //     this.dialogVisible = true;
                //     this.postFunc('/erp/advance.redeem.info',{id:obj.id},res=>{
                //         this.form_params = res.data.data;
                //         this.form_paramstot = this.form_params.total;
                //         this.issuing_balance = this.form_params.issuing_balance;
                //         this.add_params.pay_amount = this.form_paramstot.payable_amount;
                //         this.form_params.redeem_date = this.formatTime(this.form_params.redeem_date+"000");
                //         this.listDetail = this.form_params.details;
                //     })
                // }
            },
            //导出 提前赎货单
            exportExcel(){
                this.$exportExecl("/erp/advance.redeem.info.export","提前赎货单",{id:this.form_params.id})
            },
            excelExport(){
                this.$exportExecl("/erp/advance.redeem.export","提前赎货",this.params)
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    redeem_amount:2,
                },total=>{
                });
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{

        }
    }
</script>
<style  scoped lang="scss">
.btnBox{
    display: flex;
    .payBtnDiv{
        padding: 5px 20px 10px 0;display: inline-block;border-right: 2px solid #eee;
    }
    .balanceDiv{
        display: inline-block;
        .banCheckboxGroup{
            display: flex;
            margin-left: 20px;
        }
        .balanceItem{
            margin-left: 20px;
            line-height: 24px;
            font-weight: 600;
            font-size: 14px;
            margin-top: 7px;
            .balanceIcon{
                position: relative;
                top: 5px;
                margin-right: 1px;
            }
            .balanceImg{
                width: 20px;
                height: 19px;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
            /*重写radio样式*/
            /deep/ .el-radio__inner{
                width: 20px;
                height: 20px;
                border-radius: 2px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner:after{
                width: 6px;
                height: 13px;
                box-sizing: content-box;
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                left: 6px;
                position: absolute;
                border-radius: 2px;
                transform-origin: center;
                transform: rotate(45deg);
                background: none;
                top: 0;
            }
        }
    }
}
.editBtnList{padding:10px;
    .editTax{float: left;margin-right:20px;}
    .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
    .editTaxinput{float: left;width:100px;}
    .editBtn{float: right;}
}
</style>